import DeliveryContainerRoutes from "./delivery_container";
import ProductivityByHarvestTeamRoutes from "./productivity_by_harvest_team";
import ProductivityByProducerExpRoutes from "./productivity_by_producer_exp";
import QueryByProviderRoutes from "./query_by_provider"
import QueryByProducersRoutes from "./query_by_producers"

export default [
  ...DeliveryContainerRoutes,
  ...ProductivityByHarvestTeamRoutes,
  ...ProductivityByProducerExpRoutes,
  ...QueryByProviderRoutes,
  ...QueryByProducersRoutes
];
